import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";
import { deleteAssessmentsNoteAsync, notesAssessmentAsync, notesPostAsync, setDeleteAssessmentNoteState } from "../../../../app/patientSlice";
import { ERROR_STATUS, SUCCESS_STATUS } from "../../../../constants";

export const useAssessmentNotes = () => {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();
  const { register, handleSubmit, reset } = useForm();

  const notes = useSelector((state) => state.patient.assessmentNotes);
  const detailAssessment = useSelector((state) => state.patient.detailAssessment);
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || {
    loading: false,
    measurementData: null,
  };
  const deleteAssessmentNoteState = useSelector((state) => state.patient.deleteAssessmentNoteState);
  const assessmentNotesLoading = useLoading(LOADING_KEYS.ASSESSMENT_NOTE);

  const [woundImageLoading, setWoundImageLoading] = useState(true);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [deleteIds, setDeleteIds] = useState(null);

  useEffect(() => {
    dispatch(notesAssessmentAsync({ patientId, assessmentId }));
  }, [assessmentId, dispatch, patientId]);

  useEffect(() => {
    if (deleteAssessmentNoteState === SUCCESS_STATUS || deleteAssessmentNoteState === ERROR_STATUS) {
      const timer = setTimeout(() => {
        dispatch(setDeleteAssessmentNoteState(null));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [dispatch, deleteAssessmentNoteState]);

  const doSubmit = (data) => {
    if (data?.notes.trim() !== "") {
      const payload = {
        assessmentId,
        patientId,
        notes: data.notes.trim(),
      };
      dispatch(notesPostAsync(payload));
    }
    reset();
  };

  const handleDeleteNote = (e) => {
    e?.preventDefault();
    dispatch(deleteAssessmentsNoteAsync(patientId, assessmentId, deleteIds, setDeleteConfirmationModal));
    setDeleteIds(null);
  };

  const handleDeleteAssessmentNote = (data) => {
    setDeleteConfirmationModal(true);
    setDeleteIds({ id: data?.sourceNoteId, assessmentId: data?.sourceAssessmentId });
  };

  return {
    register,
    handleSubmit,
    reset,
    doSubmit,
    notes,
    detailAssessment,
    measurementData,
    deleteAssessmentNoteState,
    assessmentNotesLoading,
    woundImageLoading,
    setWoundImageLoading,
    deleteConfirmationModal,
    setDeleteConfirmationModal,
    deleteIds,
    handleDeleteNote,
    handleDeleteAssessmentNote,
  };
};
